module.exports = __webpack_public_path__ + "img/9.a8d4cebd.jpg";